export const errorHandler = (error) => {
  if (error?.response?.status === 400) {
    alert(error?.response?.data?.reason);
  } else {
    alert("일시적인 오류입니다.");
  }
};
